// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".extended-gossip[data-v-4bc2abe8]{color:#e03f19;text-decoration:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
